<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  {{ 'Contact' | translate }}

  <button mat-icon-button [mat-dialog-close]="true" class="close-button" aria-label="close">
    <mat-icon fontIcon="close" />
  </button>
</h2>

<mat-dialog-content>
  <p [innerHTML]="'CONTACT_CONTENT_1' | translate"></p>
  <a href="https://github.com/lebesnec/solar-system/discussions" target="_blank" mat-stroked-button>
    <mat-icon inline fontIcon="forum" />&nbsp;github.com/lebesnec/solar-system
  </a>
  <a href="mailto:christophe.lebesnerais.pro@gmail.com" target="_blank" mat-stroked-button>
    <mat-icon inline fontIcon="mail" />&nbsp;christophe.lebesnerais.pro&#64;gmail.com
  </a>
</mat-dialog-content>
